import { Tooltip } from "@mui/material";
import { t } from "i18next";
import React, { CSSProperties } from "react";
import { fruitNonUnileverPlotQuantity, fruitQuantity, fruitUnileverPlotQuantity, percentPpunchOnGMV, totalPpunch } from "../../helper/contractHelper";
import { isBigQuantityNb } from "../../helper/helper";
import { ContractUnilever } from "../../models/contract/ContractUnilever";
import { colorPrimary } from "../../rsc/colors/colors";
import { ReactComponent as InfoIcon } from "../../rsc/ic_info.svg";

type ReportBarSummaryProps = {
    contracts: ContractUnilever[]
}

export function ReportBarSummary({ contracts }: ReportBarSummaryProps) {

    const boxStyle2: CSSProperties = {
        flex: "2",
        display: "flex"
    }

    const fNonUlQuantity = fruitNonUnileverPlotQuantity(contracts)
    const fuQuantity = fruitUnileverPlotQuantity(contracts)

    return (
        <div style={{ display: "flex", gap: "3px", margin: "10px 0px", alignItems: "stretch" }}>
            <div style={boxStyle2}>
                <div className="sidebar-section-container">
                    <p className="sidebar-section-title">{t("fruit_non_unilever_volume")}</p>
                    <div style={{ marginTop: "4px", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "flex-end", gap:"4px" }}>
                        <p className="sidebar-number">{fNonUlQuantity.toIndoFormatTons(0)}</p>
                        <p className="sidebar-suffix">{isBigQuantityNb(fNonUlQuantity) ? 't' : 'kg'}</p>
                    </div>
                </div>
            </div>
            <div style={boxStyle2}>
                <div className="sidebar-section-container">
                    <p className="sidebar-section-title">{t("fruit_unilever_volume")}</p>
                    <div style={{ marginTop: "4px", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "flex-end", gap:"4px" }}>
                        <p className="sidebar-number">{fuQuantity.toIndoFormatTons(0)}</p>
                        <p className="sidebar-suffix">{isBigQuantityNb(fuQuantity) ? 't' : 'kg'}</p>
                    </div>
                </div>
            </div>
            <div style={boxStyle2}>
                <div className="sidebar-section-container">
                    <p className="sidebar-section-title">{t("ppunch_given")}</p>
                    <div style={{ marginTop: "4px", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "flex-end" }}>
                        <p className="sidebar-number">{(totalPpunch(contracts) / 1000 / 1000).IndoFormat(2)}</p>
                        <p className="sidebar-suffix">jt</p>
                    </div>
                </div>
            </div>
            <div style={boxStyle2}>
                <div className="sidebar-section-container" style={{ position: "relative" }}>
                    <Tooltip title={t('info_report_ppunch_gmv')} style={{ position: "absolute", right: "10px", top:"10px" }}>
                        <InfoIcon fill={colorPrimary()} width={"15px"} height={"15px"} />
                    </Tooltip>
                    <p className="sidebar-section-title">{t("ppunch_on_gmv")}</p>
                    <div style={{ marginTop: "4px", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "flex-end" }}>
                        <p className="sidebar-number">{(percentPpunchOnGMV(contracts)).IndoFormat(3)}</p>
                        <p className="sidebar-suffix">%</p>
                    </div>
                </div>
            </div>
        </div>
    )
}